export default __webpack_public_path__ + "static/Card5-8b88a9ec0ea4695692fb14ac5b26b37f.png";